import * as React from 'react';
import styled from 'styled-components';
import { useNavigate , useLocation } from 'react-router-dom';
import { useRecoilValue , useRecoilState } from 'recoil';//取得のみ
import { configJsonState } from "../../states/configJsonState";


import BarLoader from "react-spinners/BarLoader";
import { NFTRecievingImage } from '../../components/01nftrecieve/nftRecieveloaderComponent';
import { NFTRecievingMessage } from '../../components/01nftrecieve/nftRecievingMessageComponent';
import { RecievedNFTInfo } from '../../components/01nftrecieve/recievedNftInfoComponent';
import { SushiFooter } from '../../components/suishiFooterComponent';
import { NFTRecieveMovie } from '../../components/01nftrecieve/nftRecieveMovie';
import { useNFTReceiveCheck } from '../../usecases/hooks/common/useNftReceiveCheck';


type Props = {

}

export const NFTRecievePage: React.FC<Props> = (props) => {

  const intervalSecondCount = React.useRef(20);
  const nav = useNavigate();
  const location = useLocation(); 
  const [useWalletAddressState, setUseWalletAddressState] = React.useState<{ useWalletAddress: string }>(location.state as { useWalletAddress: string });
  const configStatus = useRecoilValue(configJsonState);


  const { getedNFTStatus, nftMintStatus } = useNFTReceiveCheck(useWalletAddressState.useWalletAddress);


  //-------------20秒ごとにチェック----------  
  React.useEffect(() => {
    const interval = setInterval(async() => { 


      const value = intervalSecondCount.current;
      intervalSecondCount.current = value + 20;
      console.log(`${value}秒経過`);

      if (value == 120) {
        // --------120秒でタイムアウトエラー画面に遷移---------
        try {
          nav('/2');
        } catch (error) {
          console.log(error);
        }
      }
    }, 20000);
    return () => clearInterval(interval);
  }, [intervalSecondCount]);
  



    const NFTRecievePageComponent = styled.main`
      min-height: calc(100vh - 60px);
      flex:1;

      text-align: center;
      color: white;
      background-repeat: no-repeat;
      background-size: 100% auto;
      font-family: 'Noto Sans JP',sans-serif;
      width: 100%;
      height: 100vh;
      justify-content: center;

      background-image: url(${configStatus.backgroundImage});
    `;
    const override: React.CSSProperties = {
      display: 'inline-block',
      width:'300px',
    };
    const RecievePageDiv = styled.div`
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    `;

    React.useEffect(()=>{
      //最上部にスクロール
      window.scrollTo(0,0);
    },[]);

  return (
    <RecievePageDiv>
      <NFTRecievePageComponent>
        <NFTRecievingMessage />
        <BarLoader cssOverride={override}/>
        {!configStatus.nftReceivingMovieUrl && <NFTRecievingImage />}
        {configStatus.nftReceivingMovieUrl && <NFTRecieveMovie/>}
        <RecievedNFTInfo />
      </NFTRecievePageComponent>
      <SushiFooter footerPragraph1='powered by' footerPragraph2='- Creating a Token-Graph Marketing Culture -'/>
    </RecievePageDiv>
  );
};